import React from 'react';
import { useLocation } from 'react-router-dom';
import ProductCompareScreen, { type ProductCompareInput } from '../screens/ProductCompareScreen';
import { mergeProductPairs, readProductPairFromSearch, type ProductPairTransfer } from '../utils/productIdentity';

type NavState = Partial<ProductPairTransfer> & {
  prefill?: ProductCompareInput['prefill'];
  pendingSide?: ProductCompareInput['pendingSide'];
};

export default function ProductComparisonScanPage(): React.JSX.Element {
  const location = useLocation();
  const state = (location.state ?? {}) as NavState;
  const products = mergeProductPairs(state.products, readProductPairFromSearch(location.search));
  return <ProductCompareScreen mode="page" input={{ products, prefill: state.prefill, pendingSide: state.pendingSide }} />;
}
